/**
 * How well a take read its line (R8). The words typed on the prompter and
 * the words heard on the take, compared — the same arithmetic the API uses
 * to place a take in a scene, so what the Record screen says matches what
 * the director will do.
 */
const FILLER = new Set(['the', 'a', 'an', 'and', 'or', 'of', 'to', 'in', 'on', 'is', 'it', 'that', 'this', 'you', 'your', 'for', 'with', 'um', 'uh']);

export function words(text: string): string[] {
  return [...new Set(text.toLowerCase().replace(/[^\p{L}\p{N}\s']/gu, ' ').split(/\s+/).filter((w) => w.length > 1 && !FILLER.has(w)))];
}

export interface Reading { share: number; missing: string[] }

/** The share of the line's words the take says, and the ones it did not. */
export function reading(line: string, said: string): Reading | null {
  const want = words(line);
  if (!want.length || !said.trim()) return null;
  const heard = new Set(words(said));
  const missing = want.filter((w) => !heard.has(w));
  return { share: (want.length - missing.length) / want.length, missing };
}

/** One line for the take's row. */
export function readingLine(r: Reading | null): string {
  if (!r) return '';
  const pct = Math.round(r.share * 100);
  if (r.missing.length === 0) return 'reads the whole line';
  return `reads ${pct}% of the line · missing: ${r.missing.slice(0, 5).join(', ')}${r.missing.length > 5 ? '…' : ''}`;
}
